let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iSUGd")).then(() => parcelRequire('9bIwZ'));